import styled, { css } from 'styled-components';
import { SecondaryColorsProps } from '../../../styles/theme/color';

export const StyledIndicator = styled.div<{ $reversedDirection: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  ${({ $reversedDirection }) =>
    !!$reversedDirection &&
    css`
      flex-direction: row-reverse;

      ${Signifier} {
        margin: 0 0 0 ${(props) => props.theme.spacing['8px']};
      }
    `}
`;

export const Label = styled.span`
  font-size: 0.9rem;
`;

export const Signifier = styled.div<{ color: SecondaryColorsProps }>`
  height: ${(props) => props.theme.spacing['8px']};
  width: ${(props) => props.theme.spacing['8px']};
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.secondary[props.color]};
  margin: 0 ${(props) => props.theme.spacing['8px']} 0 0;
`;
